import { Injectable } from '@angular/core';
import { CustomAjax } from '../AjaxHelper';
import { BehaviorSubject, Observable } from 'rxjs';
import { PasswordResetRequest, User_Login, User_PasswordAdmin, MenuItems } from '../AllTableClasses';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  constructor(private ajax: CustomAjax) { }

  public login(model: User_Login, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/Account/Login", model, (data: any) => {
      if (fn) {
        fn(data);
      }
    }, (error: any) => {
      if (fnError) {
        fnError(error);
      }
    });
  }

  public UserPasswordSet(user: User_PasswordAdmin, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/Account/UserPasswordSet", user,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public ForgotPasswordRequestSet(request: PasswordResetRequest, fn: (data: any) => void, fnError: (error: any) => void): any {
    request.Password = this.generateStrongPassword(12, true, false, true);
    this.ajax.PostData("/Account/ForgotPasswordRequestSet", request,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public ForgotPasswordRequestGet(GuidGeneratedForUser: string, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.GetData("/Account/ForgotPasswordRequestGet", `GuidGeneratedForUser=${GuidGeneratedForUser}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public UserPasswordReset(request: PasswordResetRequest, fn: (data: any) => void, fnError: (error: any) => void): any {
    this.ajax.PostData("/Account/UserPasswordReset", request,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => {
        if (fnError)
          fnError(error);
      }
    );
  }

  public generateStrongPassword(length: number, addUpper: boolean, addSymbols: boolean, addNums: boolean) {
    var lower = "abcdefghijklmnopqrstuvwxyz";
    var upper = addUpper ? lower.toUpperCase() : "";
    var nums = addNums ? "0123456789" : "";
    var symbols = addSymbols ? "!#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~" : "";

    var all = lower + upper + nums + symbols;
    while (true) {
      var pass = "";
      for (var i = 0; i < length; i++) {
        pass += all[Math.random() * all.length | 0];
      }

      // criteria:
      if (!/[a-z]/.test(pass)) continue; // lowercase is a must
      if (addUpper && !/[A-Z]/.test(pass)) continue; // check uppercase
      if (addSymbols && !/\W/.test(pass)) continue; // check symbols
      if (addNums && !/\d/.test(pass)) continue; // check nums

      return pass; // all good
    };
  };

  public CustomerSetGenerateXML(customerCode: string, fn: (data: any) => void, fnError: (error: any) => void) {
    this.ajax.PostData("/Account/CustomerSetGenerateXML", `customerCode= ${customerCode}`,
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => { });
  }

  public memberSessioncheck(fn: (data: any) => void, fnError: (error: any) => void) {
    this.ajax.GetData("/Account/memberSessioncheck", "",
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => { });
  }

  public removeMemberSessionCookie(fn: (data: any) => void, fnError: (error: any) => void) {
    this.ajax.GetData("/Account/removeMemberSessionCookie", "",
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => { });
  }

  public LoginByGuid(Guid: string, fn: (data: any) => void, fnError: (error: any) => void) {
    this.ajax.PostData("/Account/LoginByGuid", { Guid: Guid },
      (data) => {
        if (fn)
          fn(data);
      },
      (error) => { });
  }
}
